import { Stack } from "@mui/material";
import AppPagination from "components/AppPagination";

export default function CustomPagination({ currentPage, setCurrentPage, rowsToShow, count }) {
  return (
    <Stack alignItems="center" marginY={4}>
      <AppPagination
        shape="rounded"
        page={currentPage}
        onChange={(_, value) => setCurrentPage(value)}
        count={Math.ceil(count / rowsToShow)}
      />
    </Stack>
  );
}
